module.exports = __webpack_public_path__ + "static/tyrant06-sq-c441ee33ca9d3136e48bb26def530401.png";